import { render, staticRenderFns } from "./afterDetail.vue?vue&type=template&id=661e8b9a&scoped=true"
import script from "./afterDetail.vue?vue&type=script&lang=js"
export * from "./afterDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661e8b9a",
  null
  
)

export default component.exports